<template>
    <div>
        <h1 class="page__title">Создание судна</h1>

        <form method="post" class="grid grid-cols-12 gap-6 mt-4" :class="{ 'disabled-form': loading }">
            <div v-if="loading" class="absolute z-100 left-0 top-0 w-full h-full flex items-center justify-center">
                <Preloader />
            </div>

            <div class="relative col-span-6">
                <label for="form-title" class="form-label">
                    Название судна
                    <sup v-if="v$.form.title.required" class="text-theme-6">*</sup>
                </label>
                <label v-if="v$.form.title.$errors.length" for="form-title" class="form-input-text-error">
                    {{ getOverrideMessage(v$.form.title.$errors[0].$message) }}
                </label>
                <input
                    id="form-title"
                    v-model="form.title"
                    type="text"
                    class="form-control w-full"
                    :class="{ 'form-input-error': v$.form.title.$errors.length }"
                    placeholder=""
                    autocomplete="off"
                />
            </div>

            <div class="relative col-span-6">
                <label for="form-slug" class="form-label">
                    Ссылка
                    <sup v-if="v$.form.slug.required" class="text-theme-6">*</sup>
                </label>
                <label v-if="v$.form.slug.$errors.length" for="form-slug" class="form-input-text-error">
                    {{ getOverrideMessage(v$.form.slug.$errors[0].$message) }}
                </label>
                <input
                    id="form-slug"
                    v-model="form.slug"
                    type="text"
                    class="form-control w-full"
                    :class="{ 'form-input-error': v$.form.slug.$errors.length }"
                    placeholder=""
                    autocomplete="off"
                />
            </div>

            <div class="relative col-span-6">
                <label for="form-title" class="form-label">
                    Выберите тур.оператора
                    <sup v-if="v$.form.providerId.required" class="text-theme-6">*</sup>
                </label>
                <select
                    id="form-type"
                    v-model="form.providerId"
                    name="type"
                    class="form-select sm:mr-2"
                    autocomplete="off"
                    :class="{ 'form-input-error': v$.form.providerId.$errors.length }"
                >
                    <option v-for="(opt, optIdx) in providers" :key="optIdx" :value="opt.id">
                        {{ opt.title }}
                    </option>
                </select>
            </div>

            <div class="relative col-span-6">
                <label for="form-title" class="form-label"> ID судна на сайте тур.оператора </label>
                <input
                    id="form-title"
                    v-model="form.shipId"
                    type="text"
                    class="form-control w-full"
                    placeholder=""
                    autocomplete="off"
                />
            </div>

            <div class="col-span-6">
                <label for="form-type" class="form-label"
                    >Тип
                    <sup v-if="v$.form.type.required" class="text-theme-6">*</sup>
                </label>
                <select
                    id="form-type"
                    v-model="form.type"
                    name="type"
                    class="form-select sm:mr-2"
                    autocomplete="off"
                    :class="{ 'form-input-error': v$.form.type.$errors.length }"
                >
                    <option v-for="(opt, optIdx) in shipTypes" :key="optIdx" :value="opt.id">
                        {{ opt.title }}
                    </option>
                </select>
            </div>

            <div class="col-span-6">
                <label for="form-ship_class" class="form-label"
                    >Класс судна
                    <sup v-if="v$.form.class.required" class="text-theme-6">*</sup>
                </label>
                <select
                    id="form-ship_class"
                    v-model="form.class"
                    name="type"
                    class="form-select sm:mr-2"
                    autocomplete="off"
                    :class="{ 'form-input-error': v$.form.class.$errors.length }"
                >
                    <option v-for="(opt, optIdx) in shipClasses" :key="optIdx" :value="opt.id">
                        {{ opt.title }}
                    </option>
                </select>
            </div>

            <div class="col-span-4">
                <label for="form-decks_number" class="form-label">Текстовое количество палуб (по проекту)</label>
                <input
                    id="form-decks_number"
                    v-model="form.decks_number"
                    type="text"
                    class="form-control w-full"
                    placeholder=""
                    autocomplete="off"
                />
            </div>

            <div class="col-span-4">
                <label for="form-decks_number_int" class="form-label">Числовое количество палуб (по проекту)</label>
                <input
                    id="form-decks_number_int"
                    v-model.number="form.decks_number_int"
                    type="number"
                    min="0"
                    class="form-control w-full"
                    placeholder=""
                    autocomplete="off"
                />
            </div>

            <div class="relative col-span-4">
                <label for="form-capacity" class="form-label"
                    >Вместимость (чел.)
                    <sup v-if="v$.form.capacity.required" class="text-theme-6">*</sup>
                </label>
                <label v-if="v$.form.capacity.$errors.length" class="form-input-text-error">
                    {{ getOverrideMessage(v$.form.capacity.$errors[0].$message) }}
                </label>
                <input
                    id="form-capacity"
                    v-model.number="form.capacity"
                    type="number"
                    min="0"
                    class="form-control w-full"
                    placeholder=""
                    autocomplete="off"
                    :class="{ 'form-input-error': v$.form.capacity.$errors.length }"
                />
            </div>

            <div class="col-span-6">
                <label for="form-country_manufacturer" class="form-label">Страна производитель</label>
                <input
                    id="form-country_manufacturer"
                    v-model="form.country_manufacturer"
                    type="text"
                    class="form-control w-full"
                    placeholder=""
                    autocomplete="off"
                />
            </div>

            <div class="col-span-6 relative">
                <label for="form-modern_date_at" class="form-label">Дата модернизации судна</label>
                <input id="form-modern_date_at" v-model="form.modern_date_at" type="date" class="form-control w-full" />
            </div>

            <div class="col-span-6" title="SEO тэг для каждого круиза на этой странице">
                <label for="form-hidden_tag" class="form-label">Скрытые тэги</label>
                <Multiselect
                    id="form-hidden_tag"
                    v-model="form.hidden_tag"
                    :options="form.hidden_tag"
                    mode="tags"
                    placeholder="SEO тэги для каждого круиза на этой странице"
                    :hide-selected="false"
                    :close-on-select="false"
                    :native="false"
                    :searchable="true"
                    :create-option="true"
                    no-results-text="Введите новый тэг и Enter чтобы создать"
                    no-options-text="Введите новый тэг и Enter чтобы создать"
                />
            </div>

            <div class="col-span-3 flex items-center pt-6 mb-5">
                <input
                    id="form-syncable"
                    v-model="form.syncable"
                    class="show-code form-check-switch mr-0 ml-3"
                    type="checkbox"
                />

                <label for="form-syncable" class="form-check-label">Включить синхронизацию круизов </label>
            </div>

            <div class="col-span-3 flex items-center pt-6 mb-5">
                <input
                    id="form-api_update_disabled"
                    v-model="form.api_update_disabled"
                    class="show-code form-check-switch mr-0 ml-3"
                    type="checkbox"
                />
                <label for="form-api_update_disabled" class="form-check-label"
                    >Отключить синхронизацию данных корабля</label
                >
            </div>

            <div class="col-span-12">
                <label class="form-label">Описание</label>
                <CustomWyswig v-model="form.description" />
            </div>

            <div class="col-span-6">
                <div class="relative">
                    <label class="form-label">
                        Изображение
                        <sup v-if="v$.form.image.required" class="text-theme-6">*</sup>
                    </label>
                    <label v-if="v$.form.image.$errors.length" class="form-image-text-error">
                        {{ getOverrideMessage(v$.form.image.$errors[0].$message) }}
                    </label>
                    <UploadImageNew v-model="form.image"></UploadImageNew>
                </div>
            </div>

            <div class="col-span-12">
                <div class="mt-3">
                    <label class="form-label">Галерея</label>
                    <UploadMultiImageNew
                        v-model="form.images"
                        v-model:delete="form.images_delete"
                    ></UploadMultiImageNew>
                </div>
            </div>

            <div class="col-span-12">
                <label class="form-label font-bold">Проект и тип</label>
                <ShipCustomFields
                    v-if="customFields.type"
                    v-model="customFields.type"
                    :meta="null"
                    :headers="customFieldsHeaders.type"
                />
            </div>

            <div class="col-span-12">
                <label class="form-label font-bold">Технические параметры судна</label>
                <ShipCustomFields
                    v-if="customFields.tech"
                    v-model="customFields.tech"
                    :meta="null"
                    :headers="customFieldsHeaders.tech"
                />
            </div>

            <div class="col-span-6">
                <label class="form-label font-bold">Услуги, предоставляемые на борту</label>
                <ShipCustomFields
                    v-if="customFields.services"
                    v-model="customFields.services"
                    :meta="null"
                    :headers="customFieldsHeaders.services"
                />
            </div>

            <div class="col-span-6">
                <label class="form-label font-bold">Что входит в стоимость</label>
                <ShipCustomFields
                    v-if="customFields.included"
                    v-model="customFields.included"
                    :meta="null"
                    :headers="customFieldsHeaders.included"
                />
            </div>

            <div class="col-span-12">
                <label class="form-label font-bold">SEO Параметры</label>
                <ShipCustomFields v-if="seo" v-model="seo" :meta="null" :headers="seoHeaders" />
            </div>

            <div class="col-span-12 flex items-center justify-end mt-5">
                <router-link to="#" class="btn btn-secondary w-24 mb-2 mr-2" @click.prevent="redirectToMainPage">
                    Отмена</router-link
                >
                <button type="submit" class="btn btn-primary mb-2 mr-2" @click.prevent="save(false)">
                    Сохранить и выйти
                </button>
                <button type="submit" class="btn btn-primary mb-2" @click.prevent="save(true)">Сохранить</button>
            </div>
        </form>
    </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import Multiselect from '@vueform/multiselect';
import Preloader from '@/components/preloader/Main';
import CustomWyswig from '@/components/base/custom-wyswig/Main';
import UploadImageNew from '@/components/upload-image/UploadImageNew';
import UploadMultiImageNew from '@/components/upload-image/UploadMultiImageNew';
import ShipCustomFields from '@/components/tables/ShipCustomFields';
import { helper as $h } from '@/utils/helper';
import { formPreparation } from '@/utils/object-to-form-data';
import { pageMixin } from '@/mixins/pageMixin';

export default {
    name: 'ShipsCreate',
    components: {
        ShipCustomFields,
        ShipCustomFields,
        UploadMultiImageNew,
        CustomWyswig,
        Multiselect,
        UploadImageNew,
        Preloader,
    },
    mixins: [pageMixin],
    setup() {
        return { v$: useVuelidate() };
    },
    validations() {
        return {
            form: {
                title: { required },
                slug: { required },
                image: { required },
                type: { required },
                providerId: { required },
                class: { required },
                capacity: { required },
                // syncable: { required },
            },
        };
    },

    data() {
        return {
            loading: false,
            form: {
                title: null,
                slug: null,
                hidden_tag: [],
                image: null,
                images: null,
                type: null,
                class: null,
                decks_number: null,
                decks_number_int: null,
                syncable: false,
                api_update_disabled: 0,
                capacity: null,
                modern_date_at: null,
                country_manufacturer: null,
                description: null,
                images_delete: [],
                providerId: null,
                shipId: null,
            },
            providers: [],
            slug: null,
            shipTypes: null,
            shipClasses: null,
            seo: [],
            seoHeaders: [
                { field: 'code', label: 'Название параметра' },
                { field: 'value', label: 'Значение' },
            ],
            customFields: {
                type: [],
                tech: [],
                services: [],
                included: [],
            },
            customFieldsHeaders: {
                type: [
                    { field: 'name', label: 'Название' },
                    { field: 'value', label: 'Значение' },
                ],
                tech: [
                    { field: 'name', label: 'Название' },
                    { field: 'value', label: 'Значение' },
                ],
                services: [{ field: 'value', label: 'Значение' }],
                included: [{ field: 'value', label: 'Значение' }],
            },
        };
    },

    async created() {
        this.$store.commit('main/setPageHeader', 'Теплоходы / Создание');
        this.getProviders();
        this.getShipInfo();
    },

    methods: {
        getOverrideMessage(message) {
            return $h.getOverrideMessage(message);
        },
        redirectToMainPage() {
            this._pMTransitionToEditPageWithQuery('ships');
        },

        async getProviders() {
            this.axios.get(`/ships/providers`).then(({ data }) => {
                this.providers = data.data;
            });
        },
        async getShipInfo() {
            this.axios.get(`/ships/create`).then(({ data }) => {
                this.shipTypes = data.types;
                this.shipClasses = data.ship_classes;
            });
        },

        getPreparedCustomFields() {
            const customFIelds = [...this.seo];

            for (let [key, val] of Object.entries(this.customFields)) {
                val.forEach((item) => {
                    customFIelds.push({ ...item, block: key });
                });
            }

            return customFIelds;
        },

        async save(flag) {
            const isFormCorrect = await this.v$.$validate();
            if (!isFormCorrect) {
                this.$notify({ text: 'Заполните все поля правильно', type: 'error' });
                return;
            }

            this.loading = true;
            this.form.seo = this.seo;
            this.form.seo = this.getPreparedCustomFields();
            const formData = formPreparation(this.form, { imagesAsObject: true });

            this.axios
                .post(`/ships`, formData)
                .then(({ data }) => {
                    if (flag) {
                        this.fetchData();
                        this.$notify(data.message);
                    } else {
                        this.redirectToMainPage();
                        // this.$router.push({ name: 'ships' });
                    }
                })
                .catch((ex) => {
                    this.errorResponse(ex);
                });

            this.loading = false;
        },
    },
};
</script>
